import React from "react";
import { Line } from "react-chartjs-2";
import { Chart } from 'chart.js';
import zoomPlugin from "chartjs-plugin-zoom";

const DemandForecastChart = (props) => {
  Chart.register(zoomPlugin);
  const options = {
    scales: {
      y: {
        suggestedMin: 0,
        suggestedMax: props?.maxChartValue,
      },
    },
    plugins: {
      zoom: {
        pan: {
          enabled: true,
          mode: "x",
          threshold: 2,
        },
        zoom: {
          wheel: {
            enabled: true,
          },
          mode: "x",
        },
      },
      legend: {
        display: true,
        position: "bottom",
        labels: {
          filter: function (legendItem, data) {
            let label = data.datasets[legendItem.datasetIndex].label || "";
            if (typeof label !== "undefined") {
            }
            return label;
          },
        },
      },
    },
    interaction: {
      mode: "index",
    },
  };
  const data = {
    labels: props.plotData?.days,
    datasets: [
      {
        label: "Demand",
        lineTension: 0,
        pointRadius: 0,
        data: props.plotData?.demand,
        stepped: true,
        borderColor: "#FFA500",
        backgroundColor: "#FFA500",
      },
      {
        label: "Forecast",
        data: props.plotData?.forecast,
        borderColor: "#800080",
        backgroundColor: "#800080",
        lineTension: 0,
        pointRadius: 0,
        stepped: true,
      },
    ],
  };
  return <Line data={data} options={options} height={"300px"} />;
};

export default DemandForecastChart;
